/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_Property_B_To_A_TitleInputs */



/**
* | output |
* | --- |
* | "Apply this property from Group B to Group A" |
*
* @param {Compare_Event_Groups_Apply_Property_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_property_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Apply_Property_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_Property_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer cette propriété du groupe B au groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenden Sie diese Eigenschaft von Gruppe B auf Gruppe A an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare questa proprietà dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенесите это свойство из группы B в группу A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar esta propiedad del Grupo B al Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将此特性从B组应用于A组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBのこの特性をグループAに適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह B की इस विशेषता को समूह A पर लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplique esta propriedade do Grupo B ao Grupo A.")
	return /** @type {LocalizedString} */ ("Apply this property from Group B to Group A")
});